import type { SetStateAction } from 'react'

export const onImageError = (setStateAction: (value: SetStateAction<boolean>) => void): void => {
  setStateAction(false)
}
